import { LoadableUserSettingsNav, metaOSUserSettingsRoutesForLeftNav } from '@ms/yammer-user-settings-page';
import type { FC, ReactNode } from 'react';
import React from 'react';
import { Route, Switch } from 'react-router-dom';

import { DefaultLeftNav } from './DefaultLeftNav';

interface AppLeftNavProps {
  readonly collapsedOverlayNav?: ReactNode;
}

export const AppLeftNav: FC<AppLeftNavProps> = ({ collapsedOverlayNav }) => (
  <Switch>
    <Route exact={true} strict={false} path={metaOSUserSettingsRoutesForLeftNav}>
      <LoadableUserSettingsNav withAppName={true} />
    </Route>
    <Route>
      <DefaultLeftNav collapsedOverlayNav={collapsedOverlayNav} />
    </Route>
  </Switch>
);
